function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _path, _g;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgOutlookPlugin = function SvgOutlookPlugin(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 144,
    fill: "none",
    viewBox: "0 0 168 144"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("mask", {
      id: "a",
      width: 122,
      height: 98,
      x: 23,
      y: 23,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: "luminance"
      },
      children: _path || (_path = /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M144.424 23.153H23.859v97.694h120.565z"
      }))
    }), _g || (_g = /*#__PURE__*/_jsxs("g", {
      mask: "url(#a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#00D639",
        d: "M144.424 62.087 98.144 27.97a23.395 23.395 0 0 0-27.705 0l-46.58 34.117v55.173h120.565z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#ABABAB",
        d: "M49.483 67.789 47.74 82.57l33.344 15.093-.272-40.406-18.022-1.182z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#ABABAB",
        d: "M69.207 84.014c5.037 0 9.12-4.08 9.12-9.113s-4.083-9.113-9.12-9.113c-5.038 0-9.121 4.08-9.121 9.113s4.083 9.113 9.12 9.113"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#ABABAB",
        d: "M81.292 53.868c0 6.7-5.436 12.13-12.14 12.13s-12.14-5.43-12.14-12.13c0-6.699 5.489-5.214 12.195-5.214s12.086-1.485 12.086 5.214z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#ABABAB",
        d: "m78.223 76.292-18.055-.165-3.094-21.047 24.16-.012z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#E84D4F",
        d: "M62.278 38.586a4.143 4.143 0 0 0 4.145-4.142 4.143 4.143 0 0 0-4.145-4.142 4.143 4.143 0 0 0-4.145 4.142 4.143 4.143 0 0 0 4.145 4.142"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#5E5E5E",
        d: "M144.423 62.16v56.083a2.6 2.6 0 0 1-.872 1.943 2.6 2.6 0 0 1-1.733.661H26.465a2.6 2.6 0 0 1-1.607-.556 2.5 2.5 0 0 1-.527-.555 2.58 2.58 0 0 1-.472-1.493V62.087L73.726 86.32a24 24 0 0 0 4.471 1.654 24.1 24.1 0 0 0 16.658-1.654z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#ABABAB",
        d: "M53.844 90.419c-4.305 0-8.734-2.364-11.614-6.213-3.204-4.283-4.055-9.835-2.335-15.23 1.085-3.405 3.525-9.535 4.87-12.65C48.817 46.941 58.329 40.702 69 40.433a8.23 8.23 0 0 1 8.438 8.015c.115 4.543-3.477 8.316-8.022 8.431-4.272.108-8.013 2.447-9.53 5.96-1.176 2.726-3.436 8.416-4.3 11.129l-.046.157c3.702.739 6.526 3.963 6.61 7.89.098 4.543-3.51 8.304-8.055 8.4q-.123.004-.25.004"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#ABABAB",
        d: "M104.611 63.694c-6.143 0-12.027-1.388-15.48-2.395q-1.305-.38-2.538-.742c-10.945-3.208-15.992-4.559-20.909-2.934-4.317 1.427-8.974-.914-10.402-5.226-1.428-4.314.915-8.967 5.23-10.394 10.001-3.305 18.69-.758 30.716 2.767q1.218.358 2.507.733c4.91 1.43 9.716 2.015 13.12 1.618a8.23 8.23 0 0 1 7.578-8.189c4.532-.363 8.501 3.016 8.863 7.545.064.809.186 3.699-.973 6.944-1.844 5.163-6.039 8.711-11.507 9.733-2.042.381-4.139.538-6.205.538zm2.27-15.93.001.026zm0-.007v.006z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#E84D4F",
        d: "M116.256 48.511a4.115 4.115 0 0 1-4.081-4.7c.5-3.464 2.26-15.025 3.967-18.398a4.117 4.117 0 0 1 5.531-1.816 4.11 4.11 0 0 1 1.817 5.527c-.742 1.505-2.237 9.417-3.167 15.862a4.116 4.116 0 0 1-4.069 3.527z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#E84D4F",
        d: "M115.107 37.183a1.495 1.495 0 0 1-1.466-1.805c.703-3.326-.569-6.36-.581-6.39a1.5 1.5 0 0 1 .783-1.964 1.495 1.495 0 0 1 1.964.774c.069.158 1.669 3.912.762 8.197a1.5 1.5 0 0 1-1.462 1.186z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "M144.039 119.606a2.6 2.6 0 0 1-.487.58L90.387 87.973l-6.094-3.691-6.095 3.691-53.34 32.318a2.5 2.5 0 0 1-.526-.555l52.883-32.04 7.078-4.29 7.077 4.29z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#E84D4F",
        d: "M75.742 90.067c-10.26 0-18.279-2.607-18.76-2.767a4.113 4.113 0 1 1 2.596-7.806c.142.046 14.97 4.818 28.726.59a4.116 4.116 0 0 1 5.145 2.721 4.11 4.11 0 0 1-2.724 5.141c-5.126 1.577-10.29 2.123-14.985 2.123z"
      })]
    }))]
  }));
};
export default SvgOutlookPlugin;